/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface MedicalAdvisorFhirIdSpecialitiesGet$Params {
  fhirId: string;
}

export function medicalAdvisorFhirIdSpecialitiesGet(http: HttpClient, rootUrl: string, params: MedicalAdvisorFhirIdSpecialitiesGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, medicalAdvisorFhirIdSpecialitiesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

medicalAdvisorFhirIdSpecialitiesGet.PATH = '/MedicalAdvisor/{fhirId}/Specialities';
